/**
 * Content of a vacancy advertisement. Use `\n` in texts to force a line break.
 */
export interface VacancyAd {
    slug: string;
    title: string;
    tagline: string;
    description: string;
    highlights: string[];
    location: string;
    photo: {
        src: string;
        alt: string;
        left: number;
        top: number;
        width: number;
    };
}

/**
 * Vacancy advertisements, reachable via /werken-bij/:slug.
 * These pages are not linked anywhere in the application.
 */
export const VACANCY_ADS: VacancyAd[] = [
    {
        slug: 'scrum-master',
        title: 'Scrum\nMaster',
        tagline: 'Structuur. Overzicht. Eigenaarschap.',
        description: 'Help onze teams zelfstandig\nen gestructureerd te werken.',
        highlights: [
            'Proces\nbewaken',
            'Blokkades\nzichtbaar maken',
            'Teams\nfaciliteren'
        ],
        location: 'Dordrecht',
        photo: {
            src: 'assets/images/werken-bij/scrum-master.jpg',
            alt: 'Scrum Master aan het werk bij Codalt',
            left: 37,
            top: 0,
            width: 80
        }
    }
];
